import { FC, lazy } from 'react';
import { useUploads } from 'src/pages/reporting/products/uploaded/overview/use-uploads';
import { useUploadsParams } from 'src/pages/reporting/products/uploaded/overview/use-uploads-params';
import { CapacityManagementRootRequest } from 'src/pages/transport/network-points/details/availability-and-price-data/overview/use-capacity-management-root';

const Page = lazy(() => import('./page'));

type Props = { capacityManagementRoot?: CapacityManagementRootRequest };

export const ReportingUploadsUploadedOverview: FC<Props> = ({
  capacityManagementRoot,
}) => {
  const pageParams = useUploadsParams();
  const uploads = useUploads({ params: pageParams.value });
  return (
    <Page
      pageParams={pageParams}
      uploads={uploads}
      capacityManagementRoot={capacityManagementRoot}
    />
  );
};
